import React, { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { AiTwotoneSave} from "react-icons/ai";
import { getPermission } from '../../../Conexiones/Conexion';
import '../../../CSS/TableAct.css'
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi, postApi, putApi } from '../../../Conexiones/Models';
import { errorMessage, errorToast, successToast, warningToast } from '../../../Utils/AlertMessage';
import SelectItem from './SelectItem';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import '../../../CSS/CheckActiv.css'
import Loading from '../../../Utils/Loading';

function ObraActividades() {
    const navigate = useNavigate();
    const [listAct,setlistActs]=useState([]);
    const [obra,setObra] = useState('');
    const [isLoading,setIsLoading]=useState(false);
    const numObra=parseInt(sessionStorage.getItem("obra"));
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/');
    }

    useEffect (()=>{
        const getAct = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,31);
            if(permiso){
                const endpoint = 'getListActObraIni/' + numObra;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setlistActs(res.data[0].actividades);
                        setObra(res.data[0].obra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio');
            }
            setIsLoading(false);
        }
        getAct();
    },[navigate,numObra,idUsuario]);

    const getAct = async () =>{
        const endpoint = 'getListActObra/' + numObra;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setlistActs(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const getColor = (nivel) => {
        if (nivel === 1) return '#142157';
        if (nivel === 2) return '#2898ee';
        if (nivel === 3) return '#0cbccc';
        return '';
    };

    const getLetra = (nivel) => {
        if (nivel === 1) return '900';
        if (nivel === 2) return '700';
        if (nivel === 3) return '500';
        return '';
    };

    //EDITAR
    const update = async (e) =>{
        e.preventDefault()
        const  arregloJson = JSON.stringify(listAct);
        const endpoint = 'cantidadPrecio/';
        const data = {listActividades:arregloJson};
        const res = await putApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="¡Registro modificado!"){
                getAct();
                successToast("EDITADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }    

    function formato(numero){
        var num = Number.parseFloat(numero).toFixed(2)
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g,',');
    }

    const onChangeInput = (e, id) => {
        const { name, value } = e.target
        const editData = listAct.map((item) => 
            item.nivel===2 ? 
            item.idND === id && name ? { ...item, [name]: value } : item
            :
            item.idNT === id && name ? { ...item, [name]: value } : item
        )
        /*console.log('name', name)
        console.log('value', value)
        console.log('id', id)
        console.log(editData)*/
        setlistActs(editData)
    }

    /* AGREGAR ACTIVIDAD INICIO */
    const [actividades, setActividades] = useState([]);
    var lista=[];
    const [isSaving, setSaving] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const handleShowAdd = async () =>{
        const endpoint = 'listActividades/' + numObra;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setActividades(res.data);
                handleShow();
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
    const handleCloseAdd = () => {
        handleClose();
        lista = [];
    }
   
    const cancelar = async () => {
        if(lista.length === 0 ){
            handleCloseAdd();
        }else{
            warningToast('¿SEGURO QUE QUIERES SALIR?','UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS',true)
            .then((result) => {
                if (result.isConfirmed) {
                    handleCloseAdd();
                }
            });
        }    
    }
    const aceptar = async () => {
        if(lista.length === 0 ){
            warningToast("NINGUNA ACTIVIDAD SELECCIONADA");
        }else{
            addActividad();
        }    
    }
    const addActividad = async () =>{
        setSaving(true);
        const  arregloJson = JSON.stringify(lista);
        const endpoint = 'createListAct/';
        const data = {listActividades:arregloJson,idObra:numObra};
        const res = await postApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="Registro creado correctamente"){
                handleCloseAdd();
                getAct();
                successToast("AGREGADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        setSaving(false);
    }
    /* AGREGAR ACTIVIDAD FIN */
   
    return (
        <div className='herramientas'>
            {
                isLoading === true ? 
                <Loading /> :
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">ELEMENTOS QUE PARTICIPAN EN LA OBRA</label>
                    </div>
                    <div className='divboton' >                                                                                             
                        <div className='boton' style={{display:'flex',justifyContent:"space-between"}}>
                            <button  className="btn btn-light btncolor"style={{justifyContent:"start"}} onClick={handleShowAdd} type="button">
                                <label className="agregar">ACTIVIDADES</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <label className="text-uppercase" style={{textAlign:"center",color:'#11294d'}}>{obra}</label>
                            {
                                listAct.length === 0 ? 
                                <button  className="btn btn-light btncolor"  disabled={true}  type="button">
                                    <label className="agregar">GUARDAR</label><AiTwotoneSave style={{fontSize:'25px'}}/>
                                </button>:
                                <button  className="btn btn-light btncolor"  onClick={update}  type="button">
                                    <label className="agregar">GUARDAR</label><AiTwotoneSave style={{fontSize:'25px'}}/>
                                </button>
                            }
                        </div>
                    </div>
                    {
                        listAct.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):
                        <div className="tabla-cajaE"  >
                            <div className="table tabla ">
                                <table className="table table-bordered " >  
                                    <thead className="encabezado" >
                                        <tr >
                                            <th>PISO</th>
                                            <th  > ACTIVIDAD </th>
                                            <th > UNIDAD </th>
                                            <th > CANTIDAD </th>
                                            <th  > PRECIO</th>
                                            <th > COSTO </th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {
                                            listAct.map(dato => {
                                                return (
                                                    <tr  key={dato.codigo} >
                                                        {dato.piso=== -1?(
                                                        <td valign="middle">PRELIMINARES</td>
                                                        ):(
                                                            dato.piso===0?(
                                                                <td valign="middle">CIMENTACION</td>
                                                                ):(<td valign="middle">{"PISO "+ dato.piso}</td>)
                                                        )}
                                                        <td valign="middle" className="text-uppercase" style={{ color:getColor(dato.nivel),fontWeight:getLetra(dato.nivel),textAlign:"left"}}>{dato.nombre}</td>
                                                        <td valign="middle" className="text-uppercase"  style={{textAlign:"center"}}>{dato.unidad}</td>
                                                            {dato.nivel===2 || dato.nivel===3?(
                                                            <td valign="middle"> <input  style={{textAlign:"center"}}
                                                            name= {dato.nivel===2?("Dcantidad"):("Tcantidad")}
                                                            defaultValue={dato.nivel===2?(dato.Dcantidad):(dato.Tcantidad)}
                                                            onChange={(e) => {dato.nivel===2?(onChangeInput (e, dato.idND)):(onChangeInput (e, dato.idNT))}}
                                                            type="number"
                                                            className='input-cantidad'
                                                            /> </td>
                                                            ):( <td></td>)}
                                                            {dato.nivel===2 ?(
                                                            <td valign="middle"><input  style={{textAlign:"center"}}
                                                            name="precio"
                                                            defaultValue={dato.precio}
                                                            onChange={(e) => onChangeInput (e, dato.idND)}
                                                            type="number"
                                                            className='input-precio'
                                                            /> </td>
                                                            ):( <td></td>)}
                                                            {dato.nivel===2 ?(
                                                            <td valign="middle" style={{textAlign:"center"}}>$ {formato(dato.Dcantidad*dato.precio)}</td>
                                                            ):( <td></td>)
                                                        }
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            }

            {/*AGREGAR ACTIVIDADES*/}
            <Modal show={show} onHide={handleClose}  id="modal-selec-actividades" backdrop="static" keyboard={false}>
                <Modal.Header className=' btncolor'>
                    <Modal.Title>SELECCIONAR ACTIVIDADES</Modal.Title>
                    <CloseButton onClick={cancelar} style={{backgroundColor:"white"}} />
                </Modal.Header>
                <Modal.Body  style={{textAlign:'left', height:'60vh', overflowY:"scroll" }} >
                    <div className="mb-3">
                        {
                            actividades.map((item,index) => (  
                                <div key={index}>
                                    {
                                        item.piso === -1 ?
                                        (<h4>PRELIMINARES</h4>):
                                        (
                                            item.piso === 0 ? 
                                            (<h4>CIMENTACION</h4>):
                                            (<h4>{"PISO "+ item.piso}</h4>)
                                        )
                                    }
                                    {item.acts.map((item, index) => <SelectItem key={index} item={item} lista={lista}/>)}
                                </div>          
                            ))
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" className="btn btn-secondary" onClick={cancelar}>CANCELAR</Button>                                               
                        { isSaving===true? 
                            <Button className="btn btn-primary" type="button" disabled >
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </Button>:
                            <Button type="button" className="btn btn-light btncolor" onClick={aceptar} >GUARDAR CAMBIOS</Button>
                        }
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default ObraActividades;



/*{listAct.map(element => (
    element.acts.map(dato=>{
          return (
              <tr  key={dato.codigo} >
              <td> {element.piso}</td>
              <td className="text-uppercase" style={{ color:getColor(dato.nivel),fontWeight:getLetra(dato.nivel),textAlign:"left"}}>{dato.nombre}</td>
              <td className="text-uppercase"  style={{textAlign:"center"}}>{dato.unidad}</td>
                  {dato.nivel===2?(
                  <td><input  style={{textAlign:"center"}}
                  name="cantidad"
                  defaultValue={dato.cantidad}
                  onChange={(e) => onChangeInput(e, dato.idND)}
                  type="number"
                  className='input-cantidad'
                  /></td>
                  ):( <td></td>)}
                  {dato.nivel===2?(
                  <td><input  style={{textAlign:"center"}}
                  name="precio"
                  defaultValue={dato.precio}
                  onChange={(e) => onChangeInput(e, dato.idND)}
                  type="number"
                  className='input-precio'
                  /> </td>
                  ):( <td></td>)}
                  {dato.nivel===2?(
                  <td  style={{textAlign:"center"}}>$ {formato(dato.cantidad*dato.precio)}</td>
                  ):( <td></td>)}
              </tr>
          )
      })
  ))}*/